export var onActionColorValues = {'onAction.primary.light':'var(--c5-30-0_2lwccmb, #1336B2)','onAction.primary.dark':'var(--c5-30-0_2lwccmd, #F2FBFF)'};
export var textColorValues = {'onLight.text.primary':'#12151A'};